module.exports = __webpack_public_path__ + "img/email-header-ambassardorship@2x.fc41f6e5.png";